import axios from 'utils/axios';
import { put } from 'redux-saga/effects';
import * as SearchGeneral from 'actions/SearchGeneral';

export function* onStudentSearchRequest({ params, cb }) {
  // console.log('onStudentSearchRequest params', params)

  const size = params.size || 15
  const page = params.page || 0
  try {
    const searchResult = yield axios.get(`/api/search/companysite/?q=${params.q}&size=${size}&page=${page}`);
    // if(page === 0) {
      yield put(SearchGeneral.onStudentSearchSuccess(searchResult.data || {}));
    // }
    // else {
    //   yield put(SearchGeneral.onStudentSearchNextSuccess(searchResult.data || {}));
    // }
    cb && cb(null, searchResult.data);
  } catch (e) {
    // if(page === 0) {
      yield put(SearchGeneral.onStudentSearchFailure({ message: e.toString(), error: e }));
    // }
    // else {
    //   yield put(SearchGeneral.onStudentSearchNextFailure({ message: e.toString(), error: e }));
    // }
    cb && cb(e);
  }
}

export function* onUserSearchRequest({ params, cb }) {
  const size = params.size || 15
  const page = params.page || 0
  try {
    const searchResult = yield axios.get(`/api/search/user/?q=${params.q}&size=${size}&page=${page}`);
    yield put(SearchGeneral.onUserSearchSuccess(searchResult.data || {}));
    cb && cb(null, searchResult.data);
  } catch (e) {
    yield put(SearchGeneral.onUserSearchFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onHitClubSearchRequest({ params, cb }) {
  const size = params.size || 15
  const page = params.page || 0
  try {
    const searchResult = yield axios.get(`/api/search/hitClub/?q=${params.q}&size=${size}&page=${page}`);
    yield put(SearchGeneral.onHitClubSearchSuccess(searchResult.data || {}));
    cb && cb(null, searchResult.data);
  } catch (e) {
    yield put(SearchGeneral.onHitClubSearchFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onCompanySearchRequest({ params, cb }) {
  const size = params.size || 15
  const page = params.page || 0
  try {
    const searchResult = yield axios.get(`/api/search/company/?q=${params.q}&size=${size}&page=${page}`);
    yield put(SearchGeneral.onCompanySearchSuccess(searchResult.data || {}));
    cb && cb(null, searchResult.data);
  } catch (e) {
    yield put(SearchGeneral.onCompanySearchFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onProductBaseSearchRequest({ params, cb }) {
  const { hitClubId, productPortfolio, page, size, q } = params;

  try {
    const res = yield axios.get(`/api/product/base/search?entityType=HIT_CLUB&entityId=${hitClubId}&productPortfolio=${productPortfolio}&page=${page || 0}&size=${size || 10}&q=${q}`);
    yield put(SearchGeneral.onProductBaseSearchSuccess(res.data));
    cb && cb(null, res.data);
  } catch (e) {
    yield put(SearchGeneral.onProductBaseSearchFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onProductOfferSearchRequest({ params, cb }) {
  const { page, size, q, productType, entityType, entityId } = params;

  try {
    const res = yield axios.get(`/api/product/offer/search?entityType=${entityType||'HIT_EVENT'}&entityId=${entityId}&page=${page || 0}&size=${size || 10}&q=${q}${!!productType && `&productType=${productType}`}`);
    yield put(SearchGeneral.onProductBaseSearchSuccess(res.data));
    cb && cb(null, res.data);
  } catch (e) {
    yield put(SearchGeneral.onProductBaseSearchFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onSearchHitMemberToChatWithRequest({ params, cb }) { 

  const { hitClubId, orderBy, orderDirection, page, size, filterHitClubId, filterHitMemberStatus, filterHasApp, q } = params;

  try {
    const res = yield axios.get(`/api/hitClub/v2/${hitClubId}/allHitMembers?page=${page || 0}&size=${size || 10}${!!filterHitClubId ? `&hitClubId=${filterHitClubId}` : ''}${!!filterHitMemberStatus ? `&hitMemberStatuses=${filterHitMemberStatus}` : ''}${typeof filterHasApp !== 'undefined' ? `&hasApp=${filterHasApp}` : ''}${!!q ? `&q=${q}` : ''}${orderBy ? '&sort=' + orderBy + ',' + orderDirection : ''}`);
    yield put(SearchGeneral.onSearchHitMemberToChatWithSuccess({ data: res.data }));

    cb && cb(null);
  } catch (e) {
    yield put(SearchGeneral.onSearchHitMemberToChatWithFailure({ message: e.toString() }));
    cb && cb(e);
  }
}